export default __webpack_public_path__ + "static/media/flaskFull.badf96f0.svg";